import React from "react";
import AdminNavbar from "./AdminNavbar";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import AdminSidebar from "./AdminSidebar";

const AdminDashboard = () => {
  const location = useLocation();
  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        {!location.pathname.includes("/org-details") && <AdminSidebar />}
        <Box sx={{ flexGrow: 1, maxWidth: "100%", overflowX: "hidden" }}>
          <AdminNavbar />
          <Box sx={{ px: 2 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;
